import { useTaxiActions, useUIActions } from "../store/useActions";
import { useSelector } from "react-redux";
import { useUserSelector } from "../store/useSelectors";
import { Fragment, useEffect, useState } from "react";
import AddressMenu from "./AddressMenu";
import CitySelector from "./CitySelector";
import OrderDetailsMenu from "./OrderDetailsMenu";
import { Divider, Input, Select, Switch } from "antd";
import { Option } from "antd/es/mentions";
import CustomButton from "./CustomButton";
import Navbar from "./Navbar";



const BaseNavbar = (props) => {
    const { setNavbar1Opened, setNavbar2Opened, setNavbarPreferencesOpened } = useUIActions();
    const { navbar1Opened, navbar2Opened, navbarPreferencesOpened, routeDisplayed } = useSelector((state) => state.ui);
    const { setBabyChair, setEmptyTrunk, setAnimlTransportation, setDriverAssistance, setComment, setCoupon, setClientPhone, setPriorityAmount } = useTaxiActions();
    const { babyChair, emptyTrunk, animalTransportation, driverAssistance, coupon, clientPhone, priorityAmount } = useSelector((state) => state.taxi);
    const user = useUserSelector();
    const isManagerOrder = props.isManagerOrder || false;
    const isMaxPlatform = props.isMaxPlatform || false;
    const orderPrice = props.price;
    const orderDuration = props.duration;
    const isFormValid = props.isFormValid || false;
    const onCreateOrder = props.onCreateOrder;
    const priorityAmounts = props.priorityAmounts || [];
    const [customPriority, setCustomPriority] = useState("");

    const { TextArea } = Input;

    useEffect(() => {
    }, coupon);

    const coupons = user.data.coupons;

    return (<Fragment>
        <Navbar
            maxHeight={"70%"}
            minHeight={"48%"}
            opened={navbar1Opened}
            setOpened={setNavbar1Opened}
            getCurrentPosition={props.getCurrentPosition}
            detectLocationButton={true}
        >
            {isManagerOrder && (
                <div style={{ padding: "12px 16px 4px" }}>
                    <div style={{ fontSize: "13px", color: "var(--text-secondary, #6b7280)", marginBottom: "6px", fontWeight: 500 }}>
                        Номер телефона заказчика
                    </div>
                    <input
                        type="tel"
                        inputMode="tel"
                        placeholder="+79991234567"
                        value={clientPhone || ""}
                        onChange={(e) => {
                            let v = e.target.value;
                            // 8XXXXXXXXXX → +7XXXXXXXXXX
                            if (/^8[0-9]/.test(v)) v = "+7" + v.slice(1);
                            setClientPhone(v);
                        }}
                        style={{
                            width: "100%",
                            fontSize: "16px",
                            padding: "10px 14px",
                            border: clientPhone ? "2px solid #10b981" : "2px solid #d1d5db",
                            borderRadius: "10px",
                            outline: "none",
                            boxSizing: "border-box",
                            color: "var(--text-primary, #111827)",
                            background: "var(--input-bg, #fff)",
                        }}
                    />
                </div>
            )}
            <CitySelector />
            <AddressMenu isEntranceRequired={true} isManagerOrder={isManagerOrder} />

            {isMaxPlatform && orderPrice && isFormValid && (
                <div style={{ padding: "8px 16px", marginTop: "4px" }}>
                    <button
                        onClick={onCreateOrder}
                        style={{
                            width: "100%",
                            padding: "14px",
                            borderRadius: "12px",
                            border: "none",
                            background: "#3b82f6",
                            color: "#fff",
                            fontSize: "16px",
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                    >
                        {isManagerOrder
                            ? "Создать заказ \u2022 " + orderPrice + " \u20bd" + (orderDuration && orderDuration !== "Not found" ? " \u2022 ~" + orderDuration + " мин" : "")
                            : "Заказать такси \u2022 " + orderPrice + " \u20bd" + (orderDuration && orderDuration !== "Not found" ? " \u2022 ~" + orderDuration + " мин" : "")
                        }
                    </button>
                </div>
            )}

            <OrderDetailsMenu onClick={() => setNavbarPreferencesOpened(true)} />
        </Navbar>

        <Navbar
            minHeight={"0%"}
            maxHeight={"90%"}
            zIndex={1003}
            opened={navbar2Opened && !routeDisplayed}
            setOpened={setNavbar2Opened}
            isInput={true}
        >
            <div className="banner-card">
                <AddressMenu isInput={true} isManagerOrder={isManagerOrder} />
            </div>
        </Navbar>

        <Navbar
            minHeight={"0%"}
            maxHeight={"70%"}
            zIndex={1003}
            opened={navbarPreferencesOpened}
            setOpened={setNavbarPreferencesOpened}
            isInput={true}
        >

            <Divider orientation="left">Другие опции</Divider>
            <div className="preferences-menu-element">
                Детское кресло
                <Switch
                    onChange={() => {
                        setBabyChair(!babyChair);
                    }}
                    checked={babyChair}
                />
            </div>
            
            <div className="preferences-menu-element">
                Пустой багажник
                <Switch
                    onChange={() => {
                        setEmptyTrunk(!emptyTrunk);
                    }}
                    checked={emptyTrunk}
                />
            </div>

            <div className="preferences-menu-element">
                Перевозка животных
                <Switch
                    onChange={() => {
                        setAnimlTransportation(!animalTransportation);
                    }}
                    checked={animalTransportation}
                />
            </div>

            <div className="preferences-menu-element">
                Помощь водителя
                <Switch
                    onChange={() => {
                        setDriverAssistance(!driverAssistance);
                    }}
                    checked={driverAssistance}
                />
            </div>

            {priorityAmounts.length > 0 && (
                <>
                    <Divider orientation="left">Надбавка водителю</Divider>

                    <div style={{ display: "flex", gap: "8px", padding: "0 16px", flexWrap: "wrap" }}>
                        {[0, ...priorityAmounts].map((amt) => (
                            <button
                                key={amt}
                                onClick={() => { setPriorityAmount(amt); setCustomPriority(""); }}
                                style={{
                                    flex: 1, padding: "10px 6px", borderRadius: "10px",
                                    border: (priorityAmount === amt && !customPriority) ? "2px solid #10b981" : "1px solid #4b5563",
                                    background: (priorityAmount === amt && !customPriority) ? "#064e3b" : "#374151",
                                    color: "#e5e7eb",
                                    fontWeight: 600, cursor: "pointer", fontSize: "14px",
                                    minWidth: "55px", color: "var(--text-primary, #111827)",
                                }}
                            >
                                {amt === 0 ? "Нет" : `+${amt} ₽`}
                            </button>
                        ))}
                    </div>
                    <div style={{ position: "relative", margin: "8px 16px 0" }}>
                        <input
                            type="number"
                            inputMode="numeric"
                            placeholder="Своя сумма"
                            value={customPriority}
                            onChange={(e) => {
                                const v = e.target.value;
                                setCustomPriority(v);
                                setPriorityAmount(v ? Number(v) : 0);
                            }}

                            style={{
                                width: "100%", fontSize: "15px", padding: "10px 40px 10px 14px",
                                border: customPriority ? "2px solid #10b981" : "1px solid #d1d5db",
                                borderRadius: "10px", outline: "none", boxSizing: "border-box",
                                color: "var(--text-primary, #111827)", background: "var(--input-bg, #fff)",
                            }}
                        />
                        {customPriority && (
                            <span style={{
                                position: "absolute", right: "10px", top: "50%",
                                transform: "translateY(-50%)", fontSize: "15px",
                                color: "var(--text-secondary, #6b7280)", pointerEvents: "none",
                            }}>₽</span>
                        )}
                    </div>
                </>
            )}

            {coupons.length > 0 && (
                <div style={{ margin: "12px 16px 0" }}>
                    <select
                        value={coupon || ""}
                        onChange={(e) => setCoupon(e.target.value ? Number(e.target.value) : null)}
                        style={{
                            width: "100%", fontSize: "15px", padding: "10px 14px",
                            border: coupon ? "2px solid #10b981" : "1px solid #d1d5db",
                            borderRadius: "10px", outline: "none", boxSizing: "border-box",
                            color: coupon ? "var(--text-primary, #111827)" : "var(--text-secondary, #9ca3af)", background: "var(--input-bg, #fff)",
                            appearance: "auto", WebkitAppearance: "auto",
                        }}
                    >
                        <option value="">Купон на скидку</option>
                        {coupons
                            .filter(c => c.type === "discount")
                            .map(c => (<option key={c.id} value={c.id}>{c.name}</option>))}
                    </select>
                </div>
            )}

            <Divider orientation="left">Комментарий к заказу</Divider>
            <div style={{ margin: "0 16px" }}>
                <TextArea
                    showCount
                    maxLength={100}
                    style={{ borderRadius: "10px" }}
                    autoSize={{ minRows: 3, maxRows: 5 }}
                    onChange={(event) => setComment(event.target.value)}
                />
            </div>

            <div className="confirm-btn-wrapper">
                <CustomButton
                    width="90vw"
                    height="4em"
                    text="Готово"
                    backgroundColor="black"
                    style={{ marginRight: 10 }}
                    onClick={() => setNavbarPreferencesOpened(false)}
                />
            </div>
        </Navbar>
    </Fragment>);
};

export default BaseNavbar;
